import React, { useState, useEffect } from "react";
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";

import MainLayout from "../../themes/layouts/Main";
import ProjectsList from "../../components/Projects/List";
import Loader from "../../themes/components/Loader";
import { fetchProjects, getAllPms } from "../../api/Project";

const ProjectsListRoute: React.FC = () => {
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const [data, setData] = useState<never[]>([]);
  const [projectManagers, setProjectManagers] = useState<
    { id: string; first_name: string; last_name: string }[]
  >([]);

  const fetchData = async () => {
    const result = await fetchProjects();
    setLoading(result.loading);
    setError(result.error);
    setData(result.data);

    // Fetch project managers
    const pmResponse = await getAllPms();
    setProjectManagers(Array.isArray(pmResponse.result) ? pmResponse.result : []);
  };

  useEffect(() => {
    void fetchData();
  }, []);

  if (loading) {
    return <Loader />;
  }

  if (error || !data) {
    return (
      <Alert severity="error">
        <AlertTitle>Error</AlertTitle>
        {error}
      </Alert>
    );
  }

  return (
    <MainLayout>
      <ProjectsList projects={data} projectManagers={projectManagers} refetch={fetchData} />
    </MainLayout>
  );
};

export default ProjectsListRoute;
